const readmoreToggle = () => { 

    /* Server a chiudere tutti gli accordion di bootstrap di base su mobile */

    const readmore = document.querySelectorAll('.readmore-toggle');
    readmore.forEach(element => {
        element.addEventListener('click',(e) =>{
            if(!element.classList.contains('collapsed')){
                element.innerHTML = 'Leggi di meno'
            }else{
                element.innerHTML = 'Leggi di più'
            }
        });
        
    });
        
};
export default readmoreToggle;